import { useCallback, useState, useEffect, useRef } from 'react'

const useAlertHandler = () => {
  const [alerts, setAlerts] = useState([])
  const isMounted = useRef(true)

  useEffect(() => {
    return () => {
      isMounted.current = false
    }
  }, [])

  const setState = (setStateFn, ...args) => {
    if (!isMounted.current) return // We are unmounted, so we don't want to update state
    setStateFn(...args)
  }

  const displayAlert = useCallback(alert => {
    setState(setAlerts, currentAlerts => [...currentAlerts, alert])
    window.scrollTo(0, 0)
  }, [])

  const clearAlerts = useCallback(() => {
    setState(setAlerts, [])
  }, [])

  return { alerts, displayAlert, clearAlerts, setAlerts }
}

export { useAlertHandler }
